import { render } from "./WeeklySummaryCard.vue?vue&type=template&id=0dcf0d19&scoped=true"
import script from "./WeeklySummaryCard.vue?vue&type=script&lang=js"
export * from "./WeeklySummaryCard.vue?vue&type=script&lang=js"

import "./WeeklySummaryCard.vue?vue&type=style&index=0&id=0dcf0d19&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dcf0d19"]])

export default __exports__